import React from "react";
import homePhoto from "../../../../Vectors/homePhoto.png";
import instagramIcon from "../../../../Vectors/Instagram.png";
import telegramIcon from "../../../../Vectors/Telegram.png";
import tiktokIcon from "../../../../Vectors/TikTok.png";
import facebookIcon from "../../../../Vectors/Facebook.png";
import whatsappIcon from "../../../../Vectors/WhatsApp.png";
import DownloadButtons from "../../../../components/DownloadButtons";
import { useTranslation } from "../../../../i18n/LanguageContext";
import "./style.css";

const socials = [
    { icon: instagramIcon, label: "Instagram", href: "#" },
    { icon: telegramIcon, label: "Telegram", href: "#" },
    { icon: tiktokIcon, label: "TikTok", href: "#" },
    { icon: facebookIcon, label: "Facebook", href: "#" },
    { icon: whatsappIcon, label: "WhatsApp", href: "#" },
];

const MainPage = () => {
    const { t } = useTranslation();
    return (
        <div className="main-content-wrapper">
            <section className="main-page">
                <div className="main-content">
                    <div className="content-container">
                        <div className="left-section">
                            <span className="hero-eyebrow">
                                {t("hero.eyebrow")}
                            </span>
                            <h1 className="title">{t("hero.title")}</h1>
                            <p className="subtitle">{t("hero.subtitle")}</p>
                            <DownloadButtons />
                            <span className="hero-platforms">
                                {t("hero.platforms")}
                            </span>
                        </div>
                        <div className="right-section">
                            <div className="hero-glow" aria-hidden="true" />
                            <img
                                src={homePhoto}
                                alt="CtrlEvents կամավորներ"
                                className="hero-image"
                            />
                        </div>
                    </div>
                    <div className="social-media-section">
                        {socials.map((s) => (
                            <a
                                key={s.label}
                                href={s.href}
                                className="social-icon"
                                aria-label={s.label}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img src={s.icon} alt="" />
                            </a>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default MainPage;
